import React from "react";

const AboutUs = () => {
  console.log("About Us");
  return <div>About Us</div>;
};

export default AboutUs;
